import { toLocaleDateString } from "@/helpers/dateHelper";
import { titleCase } from "@/helpers/stringHelper";
import { UserResponse } from "@/models/api/UserResponse";
import { LoginResponse } from "@/models/api/LoginResponse";
import { UserType, CustomerType } from "@/models/enums";

export class User {
    email: string;
    firstName: string;
    lastName: string;
    type: UserType;
    phone: string;
    customerType: CustomerType;
    address?: string;
    city?: string;
    zip?: string;
    countryCode?: string;

    constructor(res: LoginResponse) {
        this.firstName = res.firstName;
        this.lastName = res.lastName;
        this.email = res.email;
        this.type = res.type;
        this.phone = res.phone;
        this.customerType = res.customerType ?? CustomerType.Default;
    }
}


export class Customer extends User {

    dateOfBirth?: string;
    title: string;
    newsletter: boolean;

    constructor(res: UserResponse) {
        super({
            email: res.email,
            phone: res.mobilePhone,
            firstName: res.firstName,
            lastName: res.lastName,
            type: UserType.Customer,
            customerType: res.customerType
        })

        this.address = res.address;
        this.city = res.city;
        this.zip = res.zip;
        this.countryCode = res.countryCode;
        this.dateOfBirth = toLocaleDateString(res.dateOfBirth);
        this.firstName = res.firstName;
        this.lastName = res.lastName;
        this.title = titleCase(res.title);
        this.newsletter = res.newsletter;
    }
}

export class Agent extends User {

    constructor(res: UserResponse) {
        super({
            email: res.email,
            phone: res.mobilePhone,
            firstName: res.firstName,
            lastName: res.lastName,
            type: UserType.Agent
        })

        this.address = res.address;
        this.city = res.city;
        this.zip = res.zip;
        this.countryCode = res.countryCode;
        this.firstName = res.firstName;
        this.lastName = res.lastName;
    }
}